/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step4body1Inputs */

const zh_landing_workflow_step4body1 = /** @type {(inputs: Landing_Workflow_Step4body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`具体、温和、贴合评分标准，学生愿意读的那种反馈。`)
};

const en_landing_workflow_step4body1 = /** @type {(inputs: Landing_Workflow_Step4body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specific, kind, rubric-aligned comments students will read.`)
};

const es_landing_workflow_step4body1 = /** @type {(inputs: Landing_Workflow_Step4body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentarios específicos, amables y alineados con la rúbrica que el alumnado leerá.`)
};

/**
* | output |
* | --- |
* | "Specific, kind, rubric-aligned comments students will read." |
*
* @param {Landing_Workflow_Step4body1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_step4body1 = /** @type {((inputs?: Landing_Workflow_Step4body1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step4body1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_step4body1(inputs)
	if (locale === "en") return en_landing_workflow_step4body1(inputs)
	return es_landing_workflow_step4body1(inputs)
});
export { landing_workflow_step4body1 as "landing_workflow_step4Body" }